import React, { useEffect, useRef, useState } from "react";
import VendorHeader from "../../../CustomComponents/Property/VendorHeader/VendorHeader";
import AgentSideBar from "../AgentSideBar/AgentSideBar";
import AgentHeader from "../AgentHeader/AgentHeader";
import AgentOverview from "../AgentOverview/AgentOverview";
import FilterPackages from "../../../CustomComponents/FilterPackages/FilterPackages";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick/lib/slider";
import Flatpickr from "react-flatpickr";
import CustomListingCard from "../../../CustomComponents/CustomListingCard/CustomListingCard";
import Skeleton from "react-loading-skeleton";
import { animateScroll as scroll } from "react-scroll";
import {
  calculateToDatePlus,
  formatIndianCurrency,
} from "../../../utils/utils";
import imgNotFound from "../../../assets/images/single-image.png";
import CustomSearchFormHolidays from "../../../CustomComponents/SearchForm/CustomSearchFormHolidays/CustomSearchFormHolidays";
import BgBackdrop from "../../../CustomComponents/BgBackDrop/BgBackDrop";
import NewHotelsSearchForm from "../../../CustomComponents/SearchForm/NewHotelsSearchForm/NewHotelsSearchForm";
import NewHolidaysSearchForm from "../../../CustomComponents/SearchForm/NewHolidaysSearchForm/NewHolidaysSearchForm";
import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";
import SearchStateInput from "../../../CustomComponents/SearchSateInput/SearchStateInput";
import SendEnquiryPopup from "../../../CustomComponents/SendEnquiryPopup/SendEnquiryPopup";
import NewSendEnquiryPopup from "../../../CustomComponents/NewSendEnquiryPopup/NewSendEnquiryPopup";
import NoDataFound from "../../../CustomComponents/NoDataFound/NoDataFound";
import CustomListingCardActivities from "../../../CustomComponents/CustomListingCardActivities/CustomListingCardActivities";
import ActivityQueryFormPopup from "../../../CustomComponents/NewSendEnquiryPopup/ActivityQueryFormPopup";
import styles from "./AgentDashboard.module.scss";
import NewAgentActivityCard from "../../../CustomComponents/NewComponents/NewUiAgent/NewAgentActivityCard";
import NewAgentPackageCard from "../../../CustomComponents/NewComponents/NewUiAgent/NewAgentPackageCard";
import CommissionChart from "../../../CustomComponents/CommissionChart/CommissionChart";

function AgentDashboard({ allPropertiesPage, vendorProperty, text }) {
  var settings = {
    speed: 500,
    centerMode: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 630,
        settings: {
          infinite: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 450,
        settings: {
          infinite: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 374,
        settings: {
          infinite: true,
          slidesToShow: 1,
        },
      },
    ],
  };
  var ActivitiesSettings = {
    speed: 500,
    centerMode: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 630,
        settings: {
          infinite: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 450,
        settings: {
          infinite: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 374,
        settings: {
          infinite: true,
          slidesToShow: 1,
        },
      },
    ],
  };

  var hotelSettings = {
    speed: 500,
    centerMode: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 630,
        settings: {
          infinite: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 450,
        settings: {
          infinite: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 374,
        settings: {
          infinite: true,
          slidesToShow: 1,
        },
      },
    ],
  };

  const [showSendEnquiryPopup, setShowSendEnquiryPopup] = useState(false);
  const [showSendEnquiryPopupActivity, setShowSendEnquiryPopupActivity] =
    useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [hotelData, setHotelData] = useState([]);
  const [activeButton, setActiveButton] = useState("holiday");
  const [activitiesData, setActivitiesData] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);

  const agentToken = localStorage.getItem("token");

  const navigate = useNavigate();
  const itemsPerPage = 9;
  const [bookingData, setBookingData] = useState({});
  const [loader, setLoader] = useState(false);
  const [packagesLoader, setPackagesLoader] = useState(false);
  const location = useLocation();
  const [adult, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [childAge, setChildAge] = useState([]);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [dataFromChild, setDataFromChild] = useState("");
  // const [stateResultArray, setStateResultArray] = useState("");
  // console.log(stateResultArray);
  const [filter, setFilter] = useState("Holidays"); // To store the selected filter

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter); // Update the filter based on the button clicked
  };

  const getDataFromChild = (data, resultArray) => {
    setDataFromChild(data);
    // setStateResultArray(resultArray)
    // console.log(resultArray);
  };
  // console.log(dataFromChild, "getDataFromChild");

  useEffect(() => {
    // Check if token is present in local storage
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  // console.log("isLoggedIn", isLoggedIn);
  const [searchFilterPopup, setSearchFilterPopup] = useState(false);

  const [guestDetails, setIsguestDetails] = useState(false);

  const [selectedLocation, setSelectedLocation] = useState(null);
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };
  // functions for increase decrease
  const onChildDecrease = (e) => {
    e.preventDefault();
    const updatedChildren = children - 1;

    setChildren(updatedChildren ? updatedChildren : 0);
    const updatedAges = childAge.slice(0, childAge.length - 1);
    setChildAge(updatedAges);
  };

  const onChildIncrease = (e) => {
    e.preventDefault();
    const updatedChildren = children + 1;
    setChildren(updatedChildren);
    setChildAge([...childAge, ""]);
  };

  const handleChildrenAgeChange = (index, event) => {
    const updatedAges = [...childAge];
    const ageValue = event.target.value.replace(/[^0-9]/g, "");

    if (ageValue > 12) {
      showErrorToast("Age should be less than or equal to 12");
      return;
    }

    updatedAges[index] = ageValue !== "" ? parseInt(ageValue, 10) : "";
    setChildAge(updatedAges);
  };

  const [destinationToggle, setdestinationToggle] = useState(false);
  const [selectDates, setselectDates] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(calculateToDatePlus(new Date(), 1));

  const onAdultIncrease = () => {
    const newAdult = adult + 1;
    setAdults(newAdult);
    if (newAdult > 1 && newAdult % 2 === 0 && rooms < newAdult / 2) {
      setRooms(rooms + 1);
    }
  };

  const onAdultDecrease = () => {
    if (adult > 1) {
      const newAdult = adult - 1;
      setAdults(newAdult);
      if (newAdult % 2 !== 0 && rooms > 1) {
        setRooms(rooms - 1);
      }
    }
  };

  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  // STATES
  const [date, setDate] = useState(new Date());
  const [selectedRadio, setSelectedRadio] = useState("");

  const [data, setData] = useState({
    fromCity: "",
    toCity: "",
  });
  //
  const [guest, setGuest] = useState(2);

  // functions for increase decrease

  const handleSubmitButtonClickHandler = async (e) => {
    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    setLoader(true);

    // console.log(children, "children");

    try {
      await navigate(
        `/agent/all-packages?location=${dataFromChild}&guest=${guest}&children=0&${childAgeParams}&radio=${selectedRadio}`,
        // `/searchresults?hotelID=&location=${property_city}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=${rooms}&adult=${adult}&children=${children}${childAgeParams}&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}#hotels`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitButtonClickHandlerOnHotels = async (e) => {
    if (!startDate || !endDate) {
      showErrorToast("Fill required detail first");
      return;
    }

    if (e) {
      e.preventDefault();
    }
    let hasChildAgeError = false;

    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      return;
    }

    setLoader(true);

    try {
      await navigate(
        `/agent/all-Hotels?hotelID=1&location=${dataFromChild}&room=${rooms}&adult=${adult}&children=0&checkinDay=${new Date(
          startDate
        ).getDate()}&checkinMonth=${
          new Date(startDate).getMonth() + 1
        }&checkinYear=${new Date(
          startDate
        ).getFullYear()}&checkoutDay=${new Date(
          endDate
        ).getDate()}&checkoutMonth=${
          new Date(endDate).getMonth() + 1
        }&checkoutYear=${new Date(
          endDate
        ).getFullYear()}&room=${rooms}&adult=${adult}&radio=${selectedRadio}`,
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APP_URL}/api/v1/customers/logout`,
        requestOptions
      );
      const result = await response.text();
      // console.log(result);
      showSuccessToast("Logged Out Successfull");
      localStorage.clear();
      setIsLoggedIn(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (destinationToggle) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [destinationToggle]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const data = {
      location: params.get("location"),
      room: params.get("room"),
      adult: params.get("adult"),
      children: params.get("children"),
      radio: params.get("radio"),
      childAge: childAges,
    };
    setBookingData(data);
    fetchPackageData(data);
    postBookingData();
    setChildren(data.children);
    setChildAge(childAges);
  }, [location.search]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const clearSelection = () => {
    // console.log("Clearing selection...");
  };

  // Calculate start and end index of items to display
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const [packageData, setPackageData] = useState([]);
  const [transportData, setTransportData] = useState([]);

  // console.log(packageData, "packageData");

  const fetchPackageData = async (data) => {
    setPackagesLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formdata = new FormData();
    // formdata.append("location", data.location);
    formdata.append("limit", 8);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = await response.json();
      setPackagesLoader(false);
      // const filteredData = result?.data?.filter(
      //   (item) => item.canBookable === 1
      // );
      // setPackageData(filteredData);
      setPackageData(result.data);
    } catch (error) {
      setPackagesLoader(false);
      setPackageData([]);
      console.error(error);
    }
  };

  // console.log(packageData);
  const postBookingData = async (data, filters) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formdata = new FormData();
    formdata.append("limit", 8);
    // formdata.append("checkIn", "2024-09-18");
    // formdata.append("checkOut", "2024-09-20");
    // formdata.append("adults", 2);
    // formdata.append("child", 0);
    // formdata.append("location", "Shimla");
    // formdata.append("rooms", 1);
    // formdata.append("PropertyType", "hotel");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/hotel-engine/check-availability`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setHotelData(result.data.properties);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      // Display error message in a toast or alert
      // showErrorToast(error.message);
    } finally {
      setLoader(false);
    }
  };

  // useEffect(() => {
  //   postBookingData();
  // }, []);

  var hotelListing = {
    slidesToShow: 4,
    speed: 500,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: "40px",
          slidesToShow: 3,
          //   arrows: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.5,
          arrows: false,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  const [markupData, setMarkupData] = useState(null);

  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          setMarkupData(findObject || null);
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  const fetchActivities = async (data, filters) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formdata = new FormData();
    formdata.append("limit", 8);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/v1/activities/fetch?price_range=${
          filters?.budget ? filters?.budget : ""
        }`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = await response.json();
      setLoader(false);
      setActivitiesData(result.data);
    } catch (error) {
      setActivitiesData([]);
      setLoader(false);
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  // const fetchTransport = async (data, filters) => {
  //   setLoader(true);
  //   const myHeaders = new Headers();
  //   myHeaders.append("Accept", "application/json");
  //   myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
  //   const formdata = new FormData();
  //   formdata.append("type", 'transport')

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: formdata,
  //     redirect: "follow",
  //   };

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch`,
  //       requestOptions
  //     );
  //     if (!response.ok) {
  //       throw new Error(`Error: ${response.statusText}`);
  //     }
  //     const result = await response.json();
  //     setLoader(false);
  //     setTransportData(result.data);
  //   } catch (error) {
  //     setTransportData([]);
  //     setLoader(false);
  //     console.error(error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  const fetchTransport = async (data) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/transport-holidays/fetch`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            key: process.env.REACT_APP_BASE_API_KEY,
            Cookie: process.env.REACT_APP_COOKIE,
          },
          // body: JSON.stringify({
          //   hub: data?.startDestination,
          //   destination: includingDestinations,
          //   days: data?.noOfDays ? Number(data?.noOfDays) : 0
          // }),
          body: JSON.stringify({
            hub: "Chandigarh",
            destination: ["Shimla", "Manali"],
            days: data?.noOfDays ? Number(data?.noOfDays) : 5,
          }),
          redirect: "follow",
        }
      );

      const result = await response.json();
      setTransportData(result.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchMarkup();
    fetchActivities();
    fetchTransport();
  }, []);

  const navigateToSingleTransport = (item) => {
    navigate(
      `/single-transport-search/${item.packagehandle}?packageId=${
        item?.packageId
      }&startdestination=Chandigarh&noOfDays=5&date=${new Date(
        date
      ).getDate()}&month=${new Date(date).getMonth() + 1}&year=${new Date(
        date
      ).getFullYear()}`,
      {
        state: {
          transportData: item,
          bookingData: bookingData,
        },
      }
    );
  };

  const calculatePriceWithMarkup = (basePrice) => {
    if (!markupData) return basePrice;

    const { markupType, amount } = markupData;

    if (markupType === "percentage") {
      const percentageAmount = (parseFloat(amount) / 100) * basePrice;
      return basePrice + percentageAmount;
    }

    if (markupType === "fixed") {
      return basePrice + parseFloat(amount);
    }

    return basePrice;
  };

  // console.log(transportData);

  return (
    <>
      <div className="sidebar_main_div new_sidebar_main_div">
        <AgentSideBar />
        <div className="agent-info-container">
          <AgentHeader showSelectProperty={true} vendorProperty={false} />

          <div className={styles.agent_dashboard_heading_sec}>
            <h4 className={styles.agent_dashboard_new_heading}>Dashboard</h4>
            {/* <Link
              className="view-all-btn fit-width"
              onClick={() => setSearchFilterPopup(true)}
            >
              Search More..
            </Link> */}

            <AgentOverview />
          </div>

          {/* <div className="booking_commission_data">
            <div className="rates_table">
              <h4 className="text-left">Recent Bookings</h4>
              <table className=" mt-10 recent_bookings_table">
                <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>Product</th>
                    <th>Status</th>
                    <th>Net Amt.</th>
                  </tr>
                  <tr>
                    <td className="booking_id">#12345</td>
                    <td>
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_7000_4106"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="19"
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7000_4106)">
                          <path
                            d="M2.91269 15.9329C2.59644 15.9329 2.3275 15.8221 2.10587 15.6004C1.88425 15.3787 1.77344 15.1097 1.77344 14.7934V3.94711C1.77344 3.63086 1.88425 3.36192 2.10587 3.1403C2.3275 2.91867 2.59644 2.80786 2.91269 2.80786H7.759C8.07525 2.80786 8.34419 2.91867 8.56581 3.1403C8.78744 3.36192 8.89825 3.63086 8.89825 3.94711V5.80786H15.0859C15.4022 5.80786 15.6711 5.91867 15.8927 6.1403C16.1144 6.36192 16.2252 6.63086 16.2252 6.94711V14.7934C16.2252 15.1097 16.1144 15.3787 15.8927 15.6004C15.6711 15.8221 15.4022 15.9329 15.0859 15.9329H2.91269ZM2.89825 14.8079H7.77344V12.9329H2.89825V14.8079ZM2.89825 11.8079H7.77344V9.93286H2.89825V11.8079ZM2.89825 8.80786H7.77344V6.93286H2.89825V8.80786ZM2.89825 5.80786H7.77344V3.93286H2.89825V5.80786ZM8.89825 14.8079H15.1004V6.93286H8.89825V14.8079ZM11.1051 9.93286C10.9458 9.93286 10.8121 9.87892 10.7043 9.77105C10.5965 9.66317 10.5426 9.52949 10.5426 9.36999C10.5426 9.21061 10.5965 9.07705 10.7043 8.9693C10.8121 8.86167 10.9458 8.80786 11.1051 8.80786H12.7493C12.9087 8.80786 13.0422 8.8618 13.15 8.96967C13.2579 9.07742 13.3118 9.21105 13.3118 9.37055C13.3118 9.53005 13.2579 9.66361 13.15 9.77124C13.0422 9.87899 12.9087 9.93286 12.7493 9.93286H11.1051ZM11.1051 12.9329C10.9458 12.9329 10.8121 12.8789 10.7043 12.771C10.5965 12.6632 10.5426 12.5295 10.5426 12.37C10.5426 12.2106 10.5965 12.077 10.7043 11.9693C10.8121 11.8617 10.9458 11.8079 11.1051 11.8079H12.7493C12.9087 11.8079 13.0422 11.8618 13.15 11.9697C13.2579 12.0774 13.3118 12.211 13.3118 12.3705C13.3118 12.53 13.2579 12.6636 13.15 12.7712C13.0422 12.879 12.9087 12.9329 12.7493 12.9329H11.1051Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                      Hotel
                    </td>
                    <td>
                      {" "}
                      <span className="confirm_status">confirmed</span>
                    </td>
                    <td>₹74,880.00</td>
                  </tr>
                  <tr>
                    <td className="booking_id">#12345</td>
                    <td>
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_7000_4652"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="19"
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7000_4652)">
                          <path
                            d="M5.21631 16.0399C4.82701 16.0399 4.49376 15.9029 4.21657 15.6287C3.93938 15.3546 3.80078 15.025 3.80078 14.64V6.3595C3.80078 5.97447 3.93938 5.64489 4.21657 5.37073C4.49376 5.09658 4.82701 4.95951 5.21631 4.95951H6.84266V3.50008C6.84266 3.11506 6.98126 2.78547 7.25845 2.51132C7.53565 2.23717 7.86889 2.1001 8.25819 2.1001H9.64337C10.0327 2.1001 10.3659 2.23717 10.6431 2.51132C10.9203 2.78547 11.0589 3.11506 11.0589 3.50008V4.95951H12.6853C13.0746 4.95951 13.4078 5.09658 13.685 5.37073C13.9622 5.64489 14.1008 5.97447 14.1008 6.3595V14.64C14.1008 15.025 13.9622 15.3546 13.685 15.6287C13.4078 15.9029 13.0746 16.0399 12.6853 16.0399V16.1292C12.6853 16.3189 12.6177 16.4805 12.4826 16.614C12.3477 16.7476 12.1843 16.8144 11.9925 16.8144C11.8008 16.8144 11.6374 16.7476 11.5025 16.614C11.3674 16.4805 11.2999 16.3189 11.2999 16.1292V16.0399H6.60169V16.1292C6.60169 16.3189 6.53415 16.4805 6.39908 16.614C6.26413 16.7476 6.10081 16.8144 5.90909 16.8144C5.71725 16.8144 5.55386 16.7476 5.41892 16.614C5.28384 16.4805 5.21631 16.3189 5.21631 16.1292V16.0399ZM5.21631 14.8783H12.6853C12.7555 14.8783 12.8132 14.856 12.8585 14.8113C12.9037 14.7666 12.9262 14.7095 12.9262 14.64V6.3595C12.9262 6.28993 12.9037 6.23281 12.8585 6.18815C12.8132 6.14349 12.7555 6.12116 12.6853 6.12116H5.21631C5.1461 6.12116 5.08835 6.14349 5.04306 6.18815C4.99791 6.23281 4.97533 6.28993 4.97533 6.3595V14.64C4.97533 14.7095 4.99791 14.7666 5.04306 14.8113C5.08835 14.856 5.1461 14.8783 5.21631 14.8783ZM7.42955 7.19356C7.26315 7.19356 7.12371 7.24919 7.01121 7.36046C6.89885 7.47185 6.84266 7.60982 6.84266 7.77439V13.2251C6.84266 13.3896 6.89898 13.5276 7.0116 13.639C7.12423 13.7503 7.26374 13.8059 7.43013 13.8059C7.59666 13.8059 7.7361 13.7503 7.84847 13.639C7.96096 13.5276 8.01721 13.3896 8.01721 13.2251V7.77439C8.01721 7.60982 7.9609 7.47185 7.84827 7.36046C7.73565 7.24919 7.59607 7.19356 7.42955 7.19356ZM10.4714 7.19356C10.3049 7.19356 10.1655 7.24919 10.0531 7.36046C9.9406 7.47185 9.88435 7.60982 9.88435 7.77439V13.2251C9.88435 13.3896 9.94066 13.5276 10.0533 13.639C10.1659 13.7503 10.3055 13.8059 10.472 13.8059C10.6384 13.8059 10.7779 13.7503 10.8904 13.639C11.0027 13.5276 11.0589 13.3896 11.0589 13.2251V7.77439C11.0589 7.60982 11.0026 7.47185 10.89 7.36046C10.7773 7.24919 10.6378 7.19356 10.4714 7.19356ZM8.01721 4.95951H9.88435V3.50008C9.88435 3.43051 9.86177 3.3734 9.81662 3.32874C9.77146 3.28408 9.71372 3.26175 9.64337 3.26175H8.25819C8.18785 3.26175 8.1301 3.28408 8.08494 3.32874C8.03979 3.3734 8.01721 3.43051 8.01721 3.50008V4.95951Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </svg>
                      Holiday
                    </td>
                    <td>
                      {" "}
                      <span className="confirm_status">confirmed</span>
                    </td>
                    <td>₹74,880.00</td>
                  </tr>
                  <tr>
                    <td className="booking_id">#12345</td>
                    <td>
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_7000_4658"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="19"
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7000_4658)">
                          <path
                            d="M5.87025 12.6298L10.6731 11.1731L12.1297 6.37025L7.32694 7.82694L5.87025 12.6298ZM8.99831 10.4808C8.72544 10.4808 8.49406 10.3853 8.30419 10.1941C8.11419 10.0031 8.01919 9.77119 8.01919 9.49831C8.01919 9.22544 8.11475 8.99406 8.30587 8.80419C8.49688 8.61419 8.72881 8.51919 9.00169 8.51919C9.27456 8.51919 9.50594 8.61475 9.69581 8.80587C9.88581 8.99688 9.98081 9.22881 9.98081 9.50169C9.98081 9.77456 9.88525 10.0059 9.69413 10.1958C9.50313 10.3858 9.27119 10.4808 8.99831 10.4808ZM9.00131 16.625C8.01581 16.625 7.0895 16.438 6.22237 16.064C5.35525 15.69 4.601 15.1824 3.95962 14.5413C3.31825 13.9002 2.81044 13.1463 2.43619 12.2795C2.06206 11.4128 1.875 10.4867 1.875 9.50131C1.875 8.51581 2.062 7.5895 2.436 6.72237C2.81 5.85525 3.31756 5.101 3.95869 4.45962C4.59981 3.81825 5.35375 3.31044 6.2205 2.93619C7.08725 2.56206 8.01331 2.375 8.99869 2.375C9.98419 2.375 10.9105 2.562 11.7776 2.936C12.6448 3.31 13.399 3.81756 14.0404 4.45869C14.6818 5.09981 15.1896 5.85375 15.5638 6.7205C15.9379 7.58725 16.125 8.51331 16.125 9.49869C16.125 10.4842 15.938 11.4105 15.564 12.2776C15.19 13.1448 14.6824 13.899 14.0413 14.5404C13.4002 15.1818 12.6463 15.6896 11.7795 16.0638C10.9128 16.4379 9.98669 16.625 9.00131 16.625ZM9 15.5C10.6672 15.5 12.0841 14.9168 13.2504 13.7504C14.4168 12.5841 15 11.1672 15 9.5C15 7.83275 14.4168 6.41594 13.2504 5.24956C12.0841 4.08319 10.6672 3.5 9 3.5C7.33275 3.5 5.91594 4.08319 4.74956 5.24956C3.58319 6.41594 3 7.83275 3 9.5C3 11.1672 3.58319 12.5841 4.74956 13.7504C5.91594 14.9168 7.33275 15.5 9 15.5Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                      Activity
                    </td>
                    <td>
                      {" "}
                      <span className="active_status">ACTIVE</span>
                    </td>
                    <td>₹74,880.00</td>
                  </tr>
                  <tr>
                    <td className="booking_id">#12345</td>
                    <td>
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_7000_4664"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="19"
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_7000_4664)">
                          <path
                            d="M4.21144 14.375V15.0817C4.21144 15.3021 4.13425 15.4894 3.97987 15.6436C3.8255 15.7979 3.638 15.875 3.41737 15.875C3.19687 15.875 3.00969 15.7979 2.85581 15.6436C2.70194 15.4894 2.625 15.3021 2.625 15.0817V9.79138C2.625 9.7135 2.63006 9.63562 2.64019 9.55775C2.65031 9.47987 2.66731 9.40525 2.69119 9.33388L4.03425 5.53662C4.12413 5.2665 4.287 5.04706 4.52288 4.87831C4.75875 4.70944 5.02275 4.625 5.31487 4.625H12.6851C12.9773 4.625 13.2413 4.70944 13.4771 4.87831C13.713 5.04706 13.8759 5.2665 13.9658 5.53662L15.3088 9.33388C15.3327 9.40525 15.3497 9.47987 15.3598 9.55775C15.3699 9.63562 15.375 9.7135 15.375 9.79138V15.0817C15.375 15.3021 15.2978 15.4894 15.1434 15.6436C14.9889 15.7979 14.8014 15.875 14.5809 15.875C14.3603 15.875 14.1731 15.7979 14.0192 15.6436C13.8654 15.4894 13.7886 15.3021 13.7886 15.0817V14.375H4.21144ZM4.20581 8.43275H13.7942L12.9058 5.9015C12.8866 5.85338 12.8577 5.81612 12.8192 5.78975C12.7807 5.76325 12.735 5.75 12.6821 5.75H5.31787C5.265 5.75 5.21931 5.76325 5.18081 5.78975C5.14231 5.81612 5.11344 5.85338 5.09419 5.9015L4.20581 8.43275ZM5.59781 12.3847C5.87069 12.3847 6.10212 12.2891 6.29212 12.098C6.482 11.907 6.57694 11.6751 6.57694 11.4022C6.57694 11.1293 6.48144 10.8979 6.29044 10.7079C6.09931 10.518 5.86731 10.4231 5.59444 10.4231C5.32156 10.4231 5.09019 10.5186 4.90031 10.7096C4.71031 10.9007 4.61531 11.1327 4.61531 11.4056C4.61531 11.6784 4.71088 11.9098 4.902 12.0997C5.093 12.2897 5.32494 12.3847 5.59781 12.3847ZM12.4056 12.3847C12.6784 12.3847 12.9098 12.2891 13.0997 12.098C13.2897 11.907 13.3847 11.6751 13.3847 11.4022C13.3847 11.1293 13.2891 10.8979 13.098 10.7079C12.907 10.518 12.6751 10.4231 12.4022 10.4231C12.1293 10.4231 11.8979 10.5186 11.7079 10.7096C11.518 10.9007 11.4231 11.1327 11.4231 11.4056C11.4231 11.6784 11.5186 11.9098 11.7096 12.0997C11.9007 12.2897 12.1327 12.3847 12.4056 12.3847ZM3.75 13.25H14.25V9.55775H3.75V13.25Z"
                            fill="#333333"
                          />
                        </g>
                      </svg>
                      Transport
                    </td>
                    <td>
                      {" "}
                      <span className="active_status">ACTIVE</span>
                    </td>
                    <td>₹74,880.00</td>
                  </tr>
                </thead>
              </table>
            </div>
            <div className="rates_table">
             
              <CommissionChart />
            </div>
          </div> */}

          <div
            style={{
              borderRadius: "15px",
              background: "white",
              padding: "10px",
              marginTop: "20px",
            }}
          >
            {/* Recommended packages */}
            <section className="">
              <div className="flex justify_content_between align_items_end">
                <div>
                  <h4 className="text-left">Recommended Packages</h4>
                </div>

                {/* <div>
                  <a className="view-all-btn fit-width p_0" href="/all-packages">
                    View All
                  </a>
                </div> */}

                {searchFilterPopup && (
                  <div className="bg_back_drop_overlay">
                    <div className="holdays-search-popup">
                      <div className="flex justify_content_between align_items_center">
                        <div></div>
                        <div className="flex flex_gap_10 justify_content_center">
                          <button
                            className="secondary_btn fit-width"
                            style={{
                              backgroundColor:
                                filter === "Holidays" ? "#016937" : null,
                              color: filter === "Holidays" ? "#fff" : "#016937",
                            }}
                            onClick={() => handleFilterChange("Holidays")}
                          >
                            Holidays
                          </button>
                          <button
                            style={{
                              backgroundColor:
                                filter === "Hotels" ? "#016937" : null,
                              color: filter === "Hotels" ? "#fff" : "#016937",
                            }}
                            className="secondary_btn fit-width"
                            onClick={() => handleFilterChange("Hotels")}
                          >
                            Hotels
                          </button>
                        </div>
                        <div className="p_10 p_top_0">
                          <svg
                            onClick={() => setSearchFilterPopup(false)}
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 13L13 1"
                              stroke="#AAAAAA"
                              strokeWidth="1.2"
                            />
                            <path
                              d="M13 13L1 1"
                              stroke="#AAAAAA"
                              strokeWidth="1.2"
                            />
                          </svg>
                        </div>
                      </div>
                      {filter === "Holidays" && (
                        <div
                          className="NewSearch-Main search_form"
                          id="NewSearch-Main"
                          style={
                            guestDetails || destinationToggle
                              ? { zIndex: "999" }
                              : { position: "" }
                          }
                        >
                          <form
                            className="search_form_main "
                            onSubmit={handleSubmitButtonClickHandler}
                          >
                            <button className="hide_radio_btn">
                              <span>All</span>
                              <svg
                                fill="#BB735D"
                                height="10px"
                                width="10px"
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 330 330"
                                xmlSpace="preserve"
                              >
                                <path
                                  id="XMLID_225_"
                                  d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
          c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
          s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                                />
                              </svg>
                            </button>
                            <div className="search_data_home">
                              <div className="search_form_div NewSearch-tags relative">
                                <label htmlFor="">From City/Destination</label>
                                <SearchStateInput
                                  onClick={() => setdestinationToggle(true)}
                                  onDataChange={getDataFromChild}
                                  dropdownGuestDetails={dropdownGuestDetails}
                                  setIsguestDetails={setIsguestDetails}
                                />
                              </div>
                              <div className="search_form_div NewSearch-tags icon_button_only">
                                <label
                                  onClick={dropdownGuestDetails}
                                  className="search_label"
                                >
                                  Guests{" "}
                                  <svg
                                    width="9"
                                    height="5"
                                    viewBox="0 0 9 5"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.25 0.75L4.75 4.25L1.25 0.75"
                                      stroke="#BB735D"
                                    />
                                  </svg>
                                </label>
                                <p
                                  style={{ position: "relative" }}
                                  className="dropdown-toggle search_form_input"
                                >
                                  <div
                                    onClick={dropdownGuestDetails}
                                    ref={dropdownRef}
                                  >
                                    <div className="optionCounter"></div>
                                    <span id="adult_count" className="font_16">
                                      {" "}
                                      <b>{guest}</b>{" "}
                                    </span>
                                    <span className="font_12"> Guests, </span>
                                    <span id="child_count" className="font_16">
                                      <b>{children}</b>
                                    </span>
                                    <span className="font_12"> Children</span>
                                  </div>
                                  {guestDetails && (
                                    <div
                                      className="guest_details_dropdown"
                                      id="guestDetailsPopup"
                                    >
                                      <div className="agent">
                                        <span>Guests</span>
                                        <div className="flex align_items_center">
                                          <button
                                            type="button"
                                            disabled={guest <= 1}
                                            className="optionCounterButton optionCounterButtonWithBorder"
                                            onClick={() => {
                                              if (guest <= 2) return;
                                              setGuest(Number(guest) - 1);
                                            }}
                                          >
                                            <span
                                              className="onclick_btn"
                                              id="adult_minus"
                                            >
                                              -
                                            </span>
                                          </button>

                                          <input
                                            className="optionCounterNumber"
                                            value={guest}
                                            min={1}
                                            type="number"
                                            onChange={(e) =>
                                              setGuest(e.target.value)
                                            }
                                          />

                                          <button
                                            type="button"
                                            disabled={guest >= 11}
                                            className="optionCounterButton optionCounterButtonWithBorder"
                                            onClick={() => {
                                              if (guest >= 11) return;
                                              setGuest(Number(guest) + 1);
                                            }}
                                          >
                                            <span
                                              className="onclick_btn"
                                              id="adult_plus"
                                            >
                                              +
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                      <div className="agent">
                                        <span>Children</span>
                                        <div>
                                          <button
                                            type="button"
                                            disabled={children <= 0}
                                            className="optionCounterButton optionCounterButtonWithBorder"
                                            onClick={onChildDecrease}
                                          >
                                            <span
                                              className="onclick_btn"
                                              id="adult_minus"
                                            >
                                              -
                                            </span>
                                          </button>

                                          <input
                                            className="optionCounterNumber"
                                            value={children}
                                            min={1}
                                          />

                                          <button
                                            type="button"
                                            // disabled={children <= 1}
                                            className="optionCounterButton optionCounterButtonWithBorder"
                                            onClick={onChildIncrease}
                                          >
                                            <span
                                              className="onclick_btn"
                                              id="adult_plus"
                                            >
                                              +
                                            </span>
                                          </button>
                                        </div>
                                      </div>

                                      {childAge.map((age, index) => (
                                        <div
                                          className="navbar agent"
                                          key={index}
                                        >
                                          <div>
                                            <span>Child Age</span>
                                          </div>
                                          <div>
                                            <input
                                              className="childAge_input"
                                              type="number"
                                              name="childAge[]"
                                              min="1"
                                              value={age}
                                              onChange={(event) =>
                                                handleChildrenAgeChange(
                                                  index,
                                                  event
                                                )
                                              }
                                              required
                                            />
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </p>
                              </div>

                              <div className="">
                                <button
                                  type="submit"
                                  className="search-btn m_0"
                                >
                                  SEARCH
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      )}
                      {filter === "Hotels" && (
                        <div
                          className="NewSearch-Main search_form"
                          id="NewSearch-Main"
                          style={
                            guestDetails || destinationToggle
                              ? { zIndex: "999" }
                              : { position: "" }
                          }
                        >
                          <form
                            className="search_form_main"
                            onSubmit={handleSubmitButtonClickHandlerOnHotels}
                          >
                            <button className="hide_radio_btn">
                              <span>All</span>
                              <svg
                                fill="#BB735D"
                                height="10px"
                                width="10px"
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 330 330"
                                xmlSpace="preserve"
                              >
                                <path
                                  id="XMLID_225_"
                                  d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                                />
                              </svg>
                            </button>

                            <div className="input_search_top search_data_home">
                              <div className="search_form_div NewSearch-tags">
                                <label htmlFor="">
                                  <small>City/Destination</small>{" "}
                                </label>
                                <SearchStateInput
                                  onClick={() => setdestinationToggle(true)}
                                  onDataChange={getDataFromChild}
                                  setIsguestDetails={setIsguestDetails}
                                />
                              </div>

                              <div
                                className="search_form_div w-100"
                                onClick={() => [
                                  setStartDate(null),
                                  setdestinationToggle(true),
                                ]}
                                setStartDate={setStartDate}
                              >
                                <label>Check In</label>
                                <Flatpickr
                                  className="search_form_input"
                                  value={startDate}
                                  onChange={([date1, date2]) => {
                                    setStartDate(date1);
                                    setEndDate(date2);
                                  }}
                                  options={{ mode: "range", minDate: "today" }}
                                  required
                                />
                              </div>
                              <div className="search_form_div w-100">
                                <label>Check Out</label>
                                <Flatpickr
                                  className="search_form_input"
                                  value={endDate}
                                  onChange={([date1, date2]) => {
                                    setStartDate(date1);
                                    setEndDate(date2);
                                  }}
                                  options={{ mode: "range", minDate: "today" }}
                                  required
                                />
                                {/* <Flatpickr
                        className="search_form_input"
                        value={endDate}
                        onChange={([date1, date2]) => {
                          setStartDate(date1);
                          setEndDate(date2);
                        }}
                        options={{ mode: "range", minDate: "today" }}
                        required
                      /> */}
                              </div>
                              <div className="search_form_div NewSearch-tags icon_button_only">
                                <label
                                  onClick={dropdownGuestDetails}
                                  className="search_label"
                                >
                                  Room & Guests{" "}
                                  <svg
                                    width="9"
                                    height="5"
                                    viewBox="0 0 9 5"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.25 0.75L4.75 4.25L1.25 0.75"
                                      stroke="#BB735D"
                                    />
                                  </svg>
                                </label>
                                <p
                                  style={{ position: "relative" }}
                                  className="dropdown-toggle search_form_input"
                                >
                                  <div
                                    onClick={dropdownGuestDetails}
                                    ref={dropdownRef}
                                  >
                                    <d iv className="optionCounter"></d>
                                    <span className="font_16" id="adult_count">
                                      <b> {adult}</b>
                                    </span>
                                    <span className="font_12"> Adults,</span>{" "}
                                    <span className="font_16" id="room_count">
                                      <b> {rooms}</b>
                                    </span>
                                    <span className="font_12"> Rooms, </span>{" "}
                                    <span className="font_16" id="child_count">
                                      <b> {children}</b>
                                    </span>
                                    <span className="font_12"> Children</span>
                                  </div>
                                  {guestDetails && (
                                    <div
                                      className="guest_details_dropdown"
                                      id="guestDetailsPopup"
                                    >
                                      <div className="agent">
                                        <span>Adult</span>
                                        <div className="flex align_items_center">
                                          <button
                                            type="button"
                                            disabled={adult <= 1}
                                            className="optionCounterButton optionCounterButtonWithBorder"
                                            onClick={onAdultDecrease}
                                          >
                                            <span
                                              className="onclick_btn"
                                              id="adult_minus"
                                            >
                                              -
                                            </span>
                                          </button>

                                          <input
                                            className="optionCounterNumber"
                                            value={adult}
                                            min={1}
                                          />

                                          <button
                                            type="button"
                                            // disabled={rooms <= 1}
                                            className="optionCounterButton optionCounterButtonWithBorder"
                                            onClick={onAdultIncrease}
                                          >
                                            <span
                                              className="onclick_btn"
                                              id="adult_plus"
                                            >
                                              +
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                      <div className="agent">
                                        <span>Rooms</span>
                                        <div>
                                          <button
                                            type="button"
                                            disabled={rooms <= 1}
                                            className="optionCounterButton optionCounterButtonWithBorder"
                                            onClick={() =>
                                              setRooms(Number(rooms) - 1)
                                            }
                                          >
                                            <span
                                              className="onclick_btn"
                                              id="adult_minus"
                                            >
                                              -
                                            </span>
                                          </button>

                                          <input
                                            className="optionCounterNumber"
                                            value={rooms}
                                            min={1}
                                          />

                                          <button
                                            type="button"
                                            // disabled={rooms <= 1}
                                            className="optionCounterButton optionCounterButtonWithBorder"
                                            onClick={() =>
                                              setRooms(Number(rooms) + 1)
                                            }
                                          >
                                            <span
                                              className="onclick_btn"
                                              id="adult_plus"
                                            >
                                              +
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                      <div className="agent">
                                        <span>Children</span>
                                        <div>
                                          <button
                                            type="button"
                                            disabled={children <= 0}
                                            className="optionCounterButton optionCounterButtonWithBorder"
                                            onClick={onChildDecrease}
                                          >
                                            <span
                                              className="onclick_btn"
                                              id="adult_minus"
                                            >
                                              -
                                            </span>
                                          </button>

                                          <input
                                            className="optionCounterNumber"
                                            value={children}
                                            min={1}
                                          />

                                          <button
                                            type="button"
                                            // disabled={children <= 1}
                                            className="optionCounterButton optionCounterButtonWithBorder"
                                            onClick={onChildIncrease}
                                          >
                                            <span
                                              className="onclick_btn"
                                              id="adult_plus"
                                            >
                                              +
                                            </span>
                                          </button>
                                        </div>
                                      </div>

                                      {childAge.map((age, index) => (
                                        // <div className="optionItem" key={index}>
                                        //   <span className="optionText">Child {index + 1} Age</span>
                                        //   <div className="optionCounter">
                                        //     <input
                                        //       className="childAge_input"
                                        //       type="number"
                                        //       name="childAge[]"
                                        //       min="1"
                                        //       value={age}
                                        //       onChange={(event) =>
                                        //         handleChildrenAgeChange(index, event)
                                        //       }
                                        //       required
                                        //     />
                                        //   </div>
                                        // </div>
                                        <div
                                          className="navbar agent"
                                          key={index}
                                        >
                                          <div>
                                            <span>Child Age</span>
                                          </div>
                                          <div>
                                            <input
                                              className="childAge_input"
                                              type="number"
                                              name="childAge[]"
                                              min="1"
                                              value={age}
                                              onChange={(event) =>
                                                handleChildrenAgeChange(
                                                  index,
                                                  event
                                                )
                                              }
                                              required
                                            />
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </p>
                              </div>

                              <div className="">
                                <button
                                  type="submit"
                                  className="search-btn m_0"
                                >
                                  SEARCH
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className={styles.package_flex}>
                {packagesLoader ? (
                  <Slider {...settings}>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <div className="card-listing">
                        <div className="hotelCardImg">
                          <Skeleton height={170} />
                        </div>
                        <div className="card_content">
                          <h6>
                            <Skeleton width={300} />
                          </h6>
                          <p>
                            <Skeleton width={100} />
                          </p>
                          <div className=" flex justify_content_between align_items_end">
                            <div>
                              <h4>
                                <Skeleton width={100} />
                              </h4>
                            </div>
                            <div>
                              {" "}
                              <h5>
                                <Skeleton width={100} />
                              </h5>
                            </div>
                          </div>
                          <div className="buttons justify_content_between">
                            <button>
                              {" "}
                              <Skeleton width={100} />
                            </button>
                            <button>
                              {" "}
                              <Skeleton width={100} />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <>
                    <Slider
                      {...settings}
                      className="new_agent_dashboard_slider"
                    >
                      {packageData &&
                        packageData
                          ?.slice(0, 10)
                          ?.map((data, index) => (
                            <NewAgentPackageCard
                              key={index}
                              imgSrc={
                                data?.featuredImage
                                  ? data?.featuredImage
                                  : imgNotFound
                              }
                              title={data.packageName}
                              packageHub={data.packageHub}
                              duration={data.totalDays}
                              nightDuration={data.totalNights}
                              price={data.startingPrice}
                              bookingLink={data.bookingLink}
                              detailsLink={data.detailsLink}
                              packagehandle={data.packagehandle}
                              canBookable={data?.canBookable}
                              packageId={data.packageId}
                              setShowSendEnquiryPopup={setShowSendEnquiryPopup}
                              markupData={markupData}
                              NoPax={data?.NoPax}
                              packageItinerary={data?.packageItinerary}
                            />
                          ))}
                    </Slider>
                  </>
                )}
              </div>
            </section>

            {/* Recommended hotels  */}
            <section className="agent_hotel_sidebar_new_btn">
              <div className="flex justify_content_between align_items_end">
                <div>
                  <h4 className="text-left mt-20">Recommended Hotels</h4>
                </div>
                {/* <div>
                  <a className="view-all-btn fit-width p_0" href="/all-hotels">
                    View All
                  </a>
                </div> */}
              </div>

              <div className="images-flex mt-10">
                {/* {!loader ? ( */}
                <Slider
                  {...hotelSettings}
                  className="new_agent_dashboard_slider"
                >
                  {hotelData &&
                    hotelData?.slice(0, 10)?.map((items, index) => {
                      const today = new Date(); // Today's date
                      const tomorrow = new Date();
                      tomorrow.setDate(today.getDate() + 1); // Tomorrow's date

                      const checkinDay = today.getDate();
                      const checkinMonth = today.getMonth() + 1; // Month is 0-indexed, so add 1
                      const checkinYear = today.getFullYear();

                      const checkoutDay = tomorrow.getDate();
                      const checkoutMonth = tomorrow.getMonth() + 1; // Month is 0-indexed, so add 1
                      const checkoutYear = tomorrow.getFullYear();

                      return (
                        <div
                          key={index}
                          onClick={() => {
                            scroll.scrollToTop({
                              duration: 500,
                              smooth: "easeInOutQuad",
                            });
                            // navigate(
                            //   `/single-hotel/${items?.hotel_slug}?hotelId=${items?.hotel_id}&location=${items?.hotel_city}&room=1&adult=2&children=0&&checkinDay=8&checkinMonth=10&checkinYear=2024&checkoutDay=9&checkoutMonth=10&checkoutYear=2024`
                            // );
                            navigate(
                              `/single-hotel-search/${items?.hotel_slug}/${items?.hotel_id}?location=${items?.hotel_city}&room=1&adult=2&children=0&checkinDay=${checkinDay}&checkinMonth=${checkinMonth}&checkinYear=${checkinYear}&checkoutDay=${checkoutDay}&checkoutMonth=${checkoutMonth}&checkoutYear=${checkoutYear}`
                            );
                          }}
                          // className="destination_link"
                          className={styles.hotel_card}
                        >
                          <div className={styles.img_sec}>
                            {items?.hotel_image &&
                            items?.hotel_image.length > 0 ? (
                              <img
                                src={items?.hotel_image[0]}
                                alt={items?.alt}
                              />
                            ) : (
                              <img src={imgNotFound} alt="image not found" />
                            )}
                          </div>

                          <div className={styles.content_sec}>
                            <div>
                              <span>
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask
                                    id="mask0_5983_7301"
                                    style={{ maskType: "alpha" }}
                                    maskUnits="userSpaceOnUse"
                                    x="0"
                                    y="0"
                                    width="18"
                                    height="18"
                                  >
                                    <rect
                                      width="18"
                                      height="18"
                                      fill="#D9D9D9"
                                    />
                                  </mask>
                                  <g mask="url(#mask0_5983_7301)">
                                    <path
                                      d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                      fill="#1C1B1F"
                                    />
                                  </g>
                                </svg>
                                {items.hotel_city}
                              </span>
                              <h4> {items.hotel_name}</h4>
                            </div>
                            <div>
                              <span
                                style={{ color: "#666666", textAlign: "end" }}
                              >
                                Starting From
                              </span>
                              <h3>
                                {formatIndianCurrency(items.starting_price)}
                              </h3>
                            </div>
                          </div>
                          {/* <div className="destination_name">
                        <div className="flex justify_content_between">
                          <div className="text-left">
                            <span className="text-left text-white">
                              {items.hotel_name}
                            </span>
                            <span className="font_11 block text-left text-white">
                              <svg
                                width="10"
                                height="12"
                                viewBox="0 0 10 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.00004 6.00008C5.32087 6.00008 5.59553 5.88585 5.824 5.65737C6.05247 5.4289 6.16671 5.15425 6.16671 4.83341C6.16671 4.51258 6.05247 4.23793 5.824 4.00946C5.59553 3.78098 5.32087 3.66675 5.00004 3.66675C4.67921 3.66675 4.40455 3.78098 4.17608 4.00946C3.94761 4.23793 3.83337 4.51258 3.83337 4.83341C3.83337 5.15425 3.94761 5.4289 4.17608 5.65737C4.40455 5.88585 4.67921 6.00008 5.00004 6.00008ZM5.00004 10.2876C6.18615 9.19869 7.06601 8.20946 7.63963 7.31987C8.21324 6.43029 8.50004 5.64036 8.50004 4.95008C8.50004 3.89036 8.16219 3.02265 7.4865 2.34696C6.8108 1.67126 5.98199 1.33341 5.00004 1.33341C4.0181 1.33341 3.18928 1.67126 2.51358 2.34696C1.83789 3.02265 1.50004 3.89036 1.50004 4.95008C1.50004 5.64036 1.78685 6.43029 2.36046 7.31987C2.93407 8.20946 3.81393 9.19869 5.00004 10.2876ZM5.00004 11.8334C3.43476 10.5015 2.26567 9.26432 1.49275 8.12196C0.719832 6.97959 0.333374 5.9223 0.333374 4.95008C0.333374 3.49175 0.802471 2.32994 1.74067 1.46466C2.67886 0.599387 3.76532 0.166748 5.00004 0.166748C6.23476 0.166748 7.32122 0.599387 8.25942 1.46466C9.19761 2.32994 9.66671 3.49175 9.66671 4.95008C9.66671 5.9223 9.28025 6.97959 8.50733 8.12196C7.73442 9.26432 6.56532 10.5015 5.00004 11.8334Z"
                                  fill="white"
                                />
                              </svg>
                              {items.hotel_city}
                            </span>
                          </div>
                          <div>
                            <span className="font_11">Starting From</span>
                            <h6>
                              {formatIndianCurrency(items.starting_price)}
                            </h6>
                          </div>
                        </div>
                      </div> */}
                        </div>
                      );
                    })}
                </Slider>
                {/* ) : (
                <Slider {...hotelListing}>
                  {Array.from({ length: 5 }).map((_, index) => {
                    return (
                      <Link
                        style={{ width: "33.33%" }}
                        className="destination_link"
                      >
                        <div>
                          <Skeleton height={300} />
                        </div>
                      </Link>
                    );
                  })}
                </Slider>
              )} */}
              </div>
            </section>

            {/* Recommended activities */}
            <section className="agent_hotel_sidebar_new_btn mt-20">
              <div className="flex justify_content_between align_items_end">
                <div>
                  <h4 className="text-left">Recommended Activities</h4>
                </div>
                {/* <div>
                  <a
                    className="view-all-btn fit-width p_0"
                    href="/all-activities"
                  >
                    View All
                  </a>
                </div> */}
              </div>
              <div className="packages_container mt-10">
                <Slider
                  {...ActivitiesSettings}
                  className="new_agent_dashboard_slider"
                >
                  {activitiesData &&
                    activitiesData?.slice(0, 10)?.map((data, index) => (
                      <NewAgentActivityCard
                        key={index}
                        imgSrc={
                          data.featuredImage ? data.featuredImage : imgNotFound
                        }
                        title={data.activityName}
                        packageHub={data.packageHub}
                        duration={1}
                        nightDuration={data.totalNights}
                        price={data.startingPrice}
                        bookingLink={data.bookingLink}
                        detailsLink={data.detailsLink}
                        packagehandle={data.packagehandle}
                        canBookable={data?.canBookable}
                        description={data?.content}
                        id={data?.activityId}
                        slug={data?.activityHandle}
                        setShowSendEnquiryPopup={setShowSendEnquiryPopup}
                        markupData={markupData}
                        sendEnquiry={() => {
                          setSelectedActivity(data);
                          setShowSendEnquiryPopup(true);
                        }}
                        activityDestination={data?.activityDestination}
                      />
                    ))}
                </Slider>

                {/* <div className={styles.activity_card_flex}>
                  {activitiesData?.slice(0, 4).map((data, index) => (
                    <NewAgentActivityCard
                      key={index}
                      imgSrc={
                        data.featuredImage ? data.featuredImage : imgNotFound
                      }
                      title={data.activityName}
                      packageHub={data.packageHub}
                      duration={1}
                      nightDuration={data.totalNights}
                      price={data.startingPrice}
                      bookingLink={data.bookingLink}
                      detailsLink={data.detailsLink}
                      packagehandle={data.packagehandle}
                      canBookable={data?.canBookable}
                      description={data?.content}
                      id={data?.activityId}
                      slug={data?.activityHandle}
                      setShowSendEnquiryPopup={setShowSendEnquiryPopup}
                      markupData={markupData}
                      sendEnquiry={() => {
                        // setSelectedActivity(data);
                        setShowSendEnquiryPopup(true);
                      }}
                      activityDestination={data?.activityDestination}
                    />
                  ))}
                </div> */}
              </div>
            </section>

            {/* Recommended Transport */}
            <section className="agent_hotel_sidebar_new_btn mt-20">
              <div className="flex justify_content_between align_items_end">
                <div>
                  <h4 className="text-left">Recommended Transport</h4>
                </div>
                {/* <div>
                  <a className="view-all-btn fit-width p_0" href="/transport">
                    View All
                  </a>
                </div> */}
              </div>
              <div className="packages_container mt-10">
                <Slider {...settings} className="new_agent_dashboard_slider">
                  {transportData &&
                    transportData?.slice(0, 10)?.map((data, index) => (
                      <div className="card-listing p_0" key={index}>
                        {data.featuredImage ? (
                          <img
                            src={data.featuredImage}
                            alt={data.packageName}
                          />
                        ) : (
                          <img src={imgNotFound} alt="Image not found" />
                        )}
                        <div
                          className="card_content"
                          style={{ marginTop: "0px" }}
                        >
                          <h6>{data?.packageName}</h6>
                          <div className="flex align_items_center flex_gap_5  mt-10">
                            <div className="day_night_div">
                              <svg
                                width="14"
                                height="15"
                                viewBox="0 0 14 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_5990_6365"
                                  style={{
                                    maskType: "alpha",
                                  }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="14"
                                  height="15"
                                >
                                  <rect
                                    y="0.5"
                                    width="14"
                                    height="14"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_5990_6365)">
                                  <path
                                    d="M9.02596 10.1407L9.64079 9.52584L7.43754 7.32259V4.58325H6.56254V7.67711L9.02596 10.1407ZM7.00106 13.0416C6.23456 13.0416 5.5141 12.8961 4.83967 12.6053C4.16523 12.3144 3.5786 11.9196 3.07975 11.4209C2.5809 10.9223 2.18594 10.3359 1.89485 9.66175C1.60387 8.98761 1.45837 8.26734 1.45837 7.50094C1.45837 6.73444 1.60382 6.01397 1.89471 5.33954C2.1856 4.66511 2.58037 4.07847 3.07902 3.57963C3.57767 3.08078 4.16407 2.68581 4.83821 2.39473C5.51235 2.10374 6.23262 1.95825 6.99902 1.95825C7.76552 1.95825 8.48599 2.1037 9.16042 2.39459C9.83485 2.68547 10.4215 3.08025 10.9203 3.5789C11.4192 4.07755 11.8141 4.66395 12.1052 5.33809C12.3962 6.01222 12.5417 6.73249 12.5417 7.4989C12.5417 8.2654 12.3963 8.98586 12.1054 9.66029C11.8145 10.3347 11.4197 10.9214 10.9211 11.4202C10.4224 11.9191 9.83601 12.314 9.16187 12.6051C8.48774 12.8961 7.76746 13.0416 7.00106 13.0416ZM7.00004 12.1666C8.2931 12.1666 9.39414 11.7121 10.3032 10.803C11.2122 9.89402 11.6667 8.79297 11.6667 7.49992C11.6667 6.20686 11.2122 5.10582 10.3032 4.19679C9.39414 3.28777 8.2931 2.83325 7.00004 2.83325C5.70698 2.83325 4.60594 3.28777 3.69692 4.19679C2.78789 5.10582 2.33337 6.20686 2.33337 7.49992C2.33337 8.79297 2.78789 9.89402 3.69692 10.803C4.60594 11.7121 5.70698 12.1666 7.00004 12.1666Z"
                                    fill="#1C1B1F"
                                  />
                                </g>
                              </svg>
                              {data?.totalNights}N/
                              {data?.totalDays}D
                            </div>
                            <div className="location_text">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_5983_7301"
                                  style={{
                                    maskType: "alpha",
                                  }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="18"
                                  height="18"
                                >
                                  <rect width="18" height="18" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_5983_7301)">
                                  <path
                                    d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                    fill="#1C1B1F"
                                  />
                                </g>
                              </svg>
                              {data.packageHub}
                            </div>
                          </div>
                          <div className="transport_card_destinations ">
                            <div className="transport_card_destinations_child">
                              <p>
                                Start City: {data?.startingPrice?.startCity}
                              </p>
                            </div>
                            <div className="transport_card_dashed_line">
                              <div className="transport_circle"></div>
                              <div className="dashed-line"></div>
                              <div className="transport_circle"></div>
                            </div>
                            <div className="transport_card_destinations_child">
                              <p>End City: {data?.startingPrice?.endCity}</p>
                            </div>
                          </div>
                          <div className="">
                            <div className="flex justify_content_end">
                              <span className="font_11">
                                Price for{" "}
                                <strong className="text-capitalize">
                                  {data?.startingPrice?.vehicleType}
                                </strong>{" "}
                                without AC
                              </span>
                            </div>
                            <h5
                              className="flex justify_content_end align_items_center "
                              style={{ color: "#333", marginTop: "5px" }}
                            >
                              {/* {
                              formatIndianCurrency(item?.startingPrice?.priceWithoutAC)} {'   '} */}
                              {formatIndianCurrency(
                                calculatePriceWithMarkup(
                                  data?.startingPrice?.priceWithoutAC
                                )
                              )}{" "}
                              {/* <span className="font_11">+ GST (%)</span> */}
                            </h5>

                            <div className="">
                              <button
                                onClick={() => navigateToSingleTransport(data)}
                                className="transport_view_btn"
                              >
                                View Details
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </Slider>
              </div>
            </section>
          </div>
        </div>
      </div>
      {/* {showSendEnquiryPopup && (
        <SendEnquiryPopup
          package_id={""}
          setshowRatePopup={setShowSendEnquiryPopup}
          typeDetail="package"
        />
      )} */}

      {showSendEnquiryPopup && (
        // <NewSendEnquiryPopup
        //   package_id={""}
        //   setshowRatePopup={setShowSendEnquiryPopup}
        //   typeDetail="package"
        // />

        <ActivityQueryFormPopup
          setshowRatePopup={setShowSendEnquiryPopup}
          typeDetail="activity"
          activityDestination={selectedActivity?.activityDestination}
          singleActivityData={selectedActivity}
        />
      )}

      {showSendEnquiryPopupActivity && selectedActivity && (
        <ActivityQueryFormPopup
          setshowRatePopup={setShowSendEnquiryPopupActivity}
          typeDetail="activity"
          activityDestination={selectedActivity.activityDestination}
          singleActivityData={selectedActivity}
        />
      )}
    </>
  );
}

export default AgentDashboard;
{
  /* {showSendEnquiryPopup && (
                  <NewSendEnquiryPopup
                    package_id={""}
                    setshowRatePopup={setShowSendEnquiryPopup}
                    typeDetail="activity"
                  />
                )} */
}
